import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { StorageService } from '../auth/storage.service';

export const authenticationGuard: CanActivateFn = (route, state) => {
  const storageService = inject(StorageService);
  const token = storageService.getToken();

  if (!token) {
    return false;
  }
  return true;
};
